// @ts-strict-ignore
import React, { useState, useRef, useEffect } from 'react'
import { IonGrid, IonItem, IonLabel } from '@ionic/react'
import { useMediaQuery } from 'react-responsive'
import classNames from 'classnames'
import {
	SectionLinkGroupContainer as Container,
	SCREEN_SECTION_LAYOUT_LIST,
	SCREEN_SECTION_LAYOUT_BUTTON,
	SCREEN_SECTION_LAYOUT_LIST_NO_ICON,
	SCREEN_SECTION_LAYOUT_BUTTON_WITH_ICON,
	SCREEN_SECTION_LAYOUT_ICON,
	SCREEN_SECTION_LAYOUT_LIST_WITH_ICON,
} from 'mytours-read-common'

import Button from '../../../common/components/Button'
import { ionHistory } from '../../../navigation'
import { linksData, onLinkAction, getSectionSubtypeAndId, getSocialLink } from '../../functions'
import { getDirMode } from '../../../platform'
import { SectionItemType } from '../../types'
import SectionHeader from './SectionHeader'
import '../styles/sectionGroup.less'
import NavigationService from 'mobile_web/modules/navigation/NavigationService'
import {
	GetCollectionItemsIndexResponseData,
	MapItem,
	GetMediaItemsShowResponse as MediaItem,
	GetScreensShowResponseSectionItems,
} from 'mytours-read-api-typescript'
import Modal from 'mobile_web/modules/common/components/modal'
import FullscreenMedia from './FullscreenMedia'
import FullscreenAr from './FullscreenAr'
import { getCollapseShadowStyle } from '../../functions'
import strings from '../../../../strings'
import '../styles/sectionCollapsable.less'

type Props = Container.Props & Container.Actions

const SectionLinkGroup: React.FC<Props> = ({
	section,
	screen,
	collection,
	collectionItemsIds,
	closeModal,
	isInsideModal,
}) => {
	const [modalPresented, setModalPresented] = useState<boolean>(false)
	const [arModalPresented, setArModalPresented] = useState<boolean>(false)
	const [glbUrl, setGlbUrl] = useState<string>()
	const [usdzUrl, setUsdzUrl] = useState<string>()
	const [arFilename, setArFilename] = useState<string>()
	const [mediaItem, setMediaItem] = useState<MediaItem>(null)
	const [isCollapsed, setCollapsed] = useState(false)
	const [blockHeight, setBlockHeight] = useState<number>()
	const contentRef = useRef<HTMLIonGridElement>()

	const isTabletOrMobile = useMediaQuery({ maxWidth: 1024.5 })

	useEffect(() => {
		const interval = setInterval(() => {
			if (contentRef?.current?.clientHeight !== 0 && !blockHeight && section?.collapsable) {
				setBlockHeight(contentRef?.current.clientHeight * section.exposable_content * 0.01)
				setCollapsed(section.exposable_content !== 100)
				clearInterval(interval)
			}
		}, 50)

		return () => clearInterval(interval)
	}, [contentRef?.current, section])

	const { section_items: sectionItems, layout, title, collapsable, exposable_content: exposableContent } = section

	const openModal = (sectionItem: SectionItemType): void => {
		const type = GetCollectionItemsIndexResponseData.ItemTypeEnum.Screen
		const subtype = sectionItem.item_subtype
			.split('_')
			.reverse()[0] as GetCollectionItemsIndexResponseData.ItemSubtypeEnum
		NavigationService.pushModalWindow(type, subtype, sectionItem.item_id)
	}

	const onModalDidPresent = (): void => setModalPresented(true)

	const onModalDidDismiss = (): void => {
		setModalPresented(false)
		setMediaItem(null)
	}

	const onArModalDidPresent = (): void => setArModalPresented(true)

	const onArModalDidDismiss = (): void => {
		setArModalPresented(false)
		setUsdzUrl(undefined)
		setGlbUrl(undefined)
		setArFilename(undefined)
	}

	const renderItems = (sectionItems: SectionItemType[]): JSX.Element[] =>
		sectionItems.map((sectionItem: SectionItemType) => renderItem(sectionItem))

	const handleOpenAr = async (mediaItem: MediaItem) => {
		const { usdz, glb } = mediaItem
		setGlbUrl(glb?.original_url)
		setUsdzUrl(usdz?.original_url)
		setArFilename(glb?.filename || usdz?.filename)
	}

	const renderItem = (sectionItem: SectionItemType): JSX.Element => {
		const { stock_icon_icon: stockIconIcon, stock_icon_style: stockIconStyle, link_type: linkType } = sectionItem
		const data = linksData[linkType]

		const isCustomIcon = stockIconIcon !== 'default'

		if (!data) {
			return null
		}

		const { subtype, id } = getSectionSubtypeAndId(sectionItem)

		const isSpecialLink = [
			GetScreensShowResponseSectionItems.LinkTypeEnum.Settings,
			GetScreensShowResponseSectionItems.LinkTypeEnum.Badges,
			GetScreensShowResponseSectionItems.LinkTypeEnum.Favourites,
		].includes(linkType)

		console.log('link', linkType, data, sectionItem)
		const href =
			linkType !== 'internal' && !isSpecialLink
				? sectionItem.url || getSocialLink(sectionItem.link_text, data.link)
				: undefined

		console.log('href', href, sectionItem, linkType, data)

		const onClickAction =
			linkType === 'internal'
				? () => {
						if ((sectionItem.item_subtype as string) === 'media_item_ar') {
							handleOpenAr(sectionItem.media_item)
						} else if (sectionItem.item_type === MapItem.ItemTypeEnum.MediaItem) {
							setMediaItem(sectionItem.media_item)
						} else {
							onLinkAction(
								subtype,
								id,
								sectionItem.item_version,
								() => openModal(sectionItem),
								() => closeModal?.(),
								collection,
								collectionItemsIds,
								sectionItem.account_id
							)
						}
				  }
				: isSpecialLink
				  ? () => ionHistory.push(data.link)
				  : undefined

		const icon = (
			<div className="icon-wrapper">
				{isCustomIcon ? (
					<i className={`brand-icon fa${stockIconStyle?.charAt?.(0)} fa-${stockIconIcon}`} />
				) : (
					<i className={classNames('brand-icon', getDirMode(), data.icon)} />
				)}
			</div>
		)

		switch (layout) {
			case SCREEN_SECTION_LAYOUT_LIST:
			case SCREEN_SECTION_LAYOUT_LIST_WITH_ICON:
			case SCREEN_SECTION_LAYOUT_LIST_NO_ICON:
				return (
					<IonItem
						key={sectionItem.id}
						onClick={onClickAction}
						href={href}
						className="item"
						target="_blank"
						rel="noreferrer"
					>
						{layout !== SCREEN_SECTION_LAYOUT_LIST_NO_ICON && icon}
						<IonLabel className="text-label">{sectionItem.link_text}</IonLabel>
					</IonItem>
				)
			case SCREEN_SECTION_LAYOUT_BUTTON:
			case SCREEN_SECTION_LAYOUT_BUTTON_WITH_ICON:
				return (
					<Button
						key={sectionItem.id}
						className="item button-item"
						fill="clear"
						onClick={onClickAction}
						href={href}
						target="_blank"
						aria-label={sectionItem.link_text || ''}
					>
						{layout === SCREEN_SECTION_LAYOUT_BUTTON_WITH_ICON && icon}
						<span className="button-item-text">{sectionItem.link_text}</span>
					</Button>
				)
			case SCREEN_SECTION_LAYOUT_ICON:
				return (
					<Button
						key={sectionItem.id}
						className="item button-item"
						fill="clear"
						onClick={onClickAction}
						href={href}
						target="_blank"
						aria-label={sectionItem.link_text || ''}
					>
						{icon}
					</Button>
				)
			default:
				return null
		}
	}

	const renderFullscreenMediaModal = (): JSX.Element => (
		<Modal
			isOpen={Boolean(mediaItem)}
			cssClass="media-modal"
			showBackdrop={true}
			onDidDismiss={onModalDidDismiss}
			onDidPresent={onModalDidPresent}
		>
			{modalPresented && (
				<FullscreenMedia mediaData={[mediaItem]} onBack={() => setMediaItem(null)} section={section} screen={screen} />
			)}
		</Modal>
	)

	const renderArModal = (): JSX.Element => (
		<Modal
			isOpen={Boolean(glbUrl) || Boolean(usdzUrl)}
			cssClass="media-modal"
			showBackdrop={true}
			onDidDismiss={onArModalDidDismiss}
			onDidPresent={onArModalDidPresent}
		>
			{arModalPresented && (
				<FullscreenAr
					usdz={usdzUrl}
					glb={glbUrl}
					filename={arFilename}
					onClose={() => {
						setGlbUrl(undefined)
						setUsdzUrl(undefined)
					}}
				/>
			)}
		</Modal>
	)

	const renderCollapseButton = (): React.ReactElement => (
		<Button onClick={() => setCollapsed(!isCollapsed)} className="collapse-btn" fill="clear">
			<i className={`fas fa-caret-${isCollapsed ? 'down' : 'up'}`} />
			<span>{isCollapsed ? strings.expand : strings.collapse}</span>
		</Button>
	)

	const isFullyCollapsed = collapsable && (exposableContent === 0 || exposableContent === 100 || blockHeight < 85)

	const getCollapsedStyles = () => {
		if (isCollapsed && exposableContent !== 0) {
			return {
				maxHeight: `${exposableContent === 100 ? 34 : blockHeight}px`,
				overflow: 'hidden',
				height: `${exposableContent === 100 ? 34 : blockHeight}px`,
			}
		}
	}

	return (
		<IonGrid
			className={classNames('section-group', `${layout.split('_').join('-')}-layout`, {
				'section-collapsable': collapsable,
				'-collapsed': isCollapsed,
				'-fully-collapsable': isFullyCollapsed,
			})}
			dir={getDirMode()}
			style={getCollapsedStyles()}
			ref={contentRef}
		>
			<SectionHeader title={title} noOverflow={isCollapsed} />
			{isFullyCollapsed && renderCollapseButton()}
			{((isFullyCollapsed && !isCollapsed) || !isFullyCollapsed) && (
				<IonGrid
					className={classNames('block-content section-group-list', getDirMode())}
					dir={getDirMode()}
					data-cy="story-screen-section-content"
				>
					{renderItems(sectionItems)}
					{collapsable && exposableContent !== 0 && exposableContent !== 100 && blockHeight >= 85 && (
						<div
							className={classNames('collapse-shadow', {
								'mobile-or-tablet-collapsed': (isTabletOrMobile || isInsideModal) && isCollapsed,
							})}
							style={{ background: getCollapseShadowStyle() }}
						>
							{renderCollapseButton()}
						</div>
					)}
				</IonGrid>
			)}
			{mediaItem && renderFullscreenMediaModal()}
			{(glbUrl || usdzUrl) && renderArModal()}
		</IonGrid>
	)
}

const SectionLinkGroupComponent = Container.default(SectionLinkGroup)
export default SectionLinkGroupComponent
